module.exports = __webpack_public_path__ + "img/price-icon.00188347.svg";